import { includes } from "ramda";
import { FeatureEnum } from "@sinch/core/entities/serverEnums.types";
import { useSettings } from "@sinch/core/providers/AppSettings";

export const useFeatures = () => {
  const { features } = useSettings();
  const featAllowed = (feature: FeatureEnum) => includes(feature, features);

  return { featAllowed };
};
